module.exports = __webpack_public_path__ + "img/Mask Group 50.bf83f354.png";